<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView"
                                 :id="`${id}_selected`"
                                 :name="`${name}[selected]`"
                                 :no-wrapper="true"
                                 :disabled="itemIsDisabled(bundle_item)"
                                 :description="bundle_item.service.service_name"
                                 :checked="itemIsSelected(bundle_item)"
                                 :model-value="itemIsSelected(bundle_item)"
                                 @change="selectStatementType(bundle_item)"
                                 :on-selected="function() {
                                                                      if(!bundle_item.terminal_quantity > 0 ){
                                                                        bundle_item.terminal_quantity = 1
                                                                        bundle_item.selected = true;
                                                                        bundle_item.is_boarding_activated = '1';
                                                                      }

                                                                    }"
                                 :on-deselected="() => {bundle_item.terminal_quantity = 0; bundle_item.selected = false;
                                 bundle_item.is_boarding_activated = '0';
                            bundle_item.service_charges.forEach(obj => obj.selected = '');
                            if(objectIsNotEmpty(bundle_item.service_features)){
                                // TODO review this with will cos this unsets but we don't reset values when selected.
                              getBundleItemFeatures(bundle_item).forEach(obj => {
                                  if(obj.collect_on_boarding === collect_on_boarding_types.BOARDING){
                                      featureDictionary[obj.feature_api_code]['selected'] = '';
                                      featureDictionary[obj.feature_api_code]['value'] = '';
                                    obj.selected = '';
                                     obj.value = '';
                              }
                            })
                            }

                            }">
                    </np-checkbox>
                    <span v-else>   {{bundle_item.service.service_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class=""  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description" >
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7">

                    <div class="" v-if="itemHasFeatures(bundle_item)">
<!--                        <span class="labelLook boldText">{{lang('features')}}</span>-->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="!!statementType">
                                <np-select2
                                        :disabled="statementType.selected !== '1' || statementType.disabled || isView"
                                        :label="statementType.feature_name"
                                        :placeholder="statementType.feature_name"
                                        :required="bundle_item.is_boarding_activated === '1' && statementType.is_required === '1'"
                                        :check_config="false"
                                        :help-text="!!statementType.help_text ? statementType.help_text : ''"
                                        :name="`${name}_statementType`"
                                        :id="`${id}_statementType`"
                                        :key="`statementType`"
                                        :parameters="getServiceFeatureList(statementType)"
                                        v-model="statementType.value">
                                </np-select2>
                            </div>
                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="isSelectedFeature('media') && !!featureDictionary['media'].is_visible">
                                <np-select2
                                        :label="featureDictionary.media.feature_name"
                                        :placeholder="featureDictionary.media.feature_name"
                                        :disabled="featureDictionary.media.selected !== '1' || featureDictionary.media.disabled || isView"
                                        :name="`${name}_media`"
                                        :id="`${id}_media`"
                                        :key="`media`"
                                        :required="bundle_item.is_boarding_activated === '1' && featureDictionary.media.is_required === '1'"
                                        :check_config="false"
                                        :help-text="!!featureDictionary.media.help_text ? featureDictionary.media.help_text : ''"
                                        @input="selectStatementEmail"
                                        :parameters="getServiceFeatureList(featureDictionary.media)"
                                        v-model="featureDictionary.media.value">
                                </np-select2>
                            </div>
                        </div>
                        <np-input
                                v-if="isSelectedFeature('emailAddress') && !!featureDictionary['emailAddress'].is_visible"
                                :label="featureDictionary.emailAddress.feature_name"
                                :placeholder="featureDictionary.emailAddress.feature_name"
                                :name="`${name}_emailAddress`"
                                :id="`${id}_emailAddress`"
                                :required="bundle_item.is_boarding_activated === '1' && featureDictionary.emailAddress.is_required === '1'"
                                :check_config="false"
                                :help-text="!!featureDictionary.emailAddress.help_text ? featureDictionary.emailAddress.help_text : ''"
                                :key="`emailAddress`"
                                :rules="['valid_email', 'required']"
                                :disabled="isView"
                                v-model="featureDictionary.emailAddress.value">
                        </np-input>
                        <np-select2
                                v-if="isSelectedFeature('frequency') && !!featureDictionary['frequency'].is_visible"
                                :label="featureDictionary.frequency.feature_name"
                                :placeholder="featureDictionary.frequency.feature_name"
                                :name="`${name}_frequency`"
                                :id="`${id}_frequency`"
                                :key="`frequency`"
                                :check_config="false"
                                :required="bundle_item.is_boarding_activated === '1' && featureDictionary.frequency.is_required === '1'"
                                :disabled="isView || featureDictionary.frequency.disabled"
                                :help-text="!!featureDictionary.frequency.help_text ? featureDictionary.frequency.help_text : ''"
                                :parameters="getServiceFeatureList(featureDictionary.frequency)"
                                v-model="featureDictionary.frequency.value">
                        </np-select2>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5">
                    <div v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{lang('charges')}}</span>
                        <div class="row">
                            <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                                <div class="col-12" v-if="!isView">
                                    <np-checkbox
                                            :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                            :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                            :no-wrapper="true"
                                            :disabled="!bundleItemIsSelected(bundle_item)"
                                            :description="getServiceChargeDescription(service_charge)"
                                            v-model="service_charge.selected">
                                    </np-checkbox>
                                </div>
                                <div class="col-12" v-else>
                            <span>
                              {{ getServiceCharge(service_charge) }}
                              {{ service_charge.service_frequency !== '1' ? `/${formatServiceFrequency(service_charge.service_frequency)}` : '' }}
                            </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import {Multiselect} from 'vue-multiselect';
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice, NPPhone,
        NPRadios,
        NPResponsive,
        NPSelect2, NPShowLess,
        NPSkeleton,

    } from "netpify/components";
    import NpMultiselect from "netpify/components/np-multiselect.vue";

    export default {
        name: "equipment-service-statement",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'multiselect': Multiselect,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-phone': NPPhone,
            'np-show-less': NPShowLess,
        },
        data() {
            return {
                statementTypes: {
                    'billingStatement': 'billingStatementType',
                    'fundingStatement': 'fundingStatementType',
                    'electronicStatement': 'electronicStatementType',
                },
                mediaTypes: {
                    'EMAIL': 'EMAIL',
                    'HARD_COPY': 'HARD_COPY',
                    'THREE': 'THREE',
                    'FOUR': 'FOUR',
                },
                featureList: [],
            }
        },
        props: {
            bundle_item: {
                default() {
                    return {}
                }
            },
            isStandalone: Boolean,
            id: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            feature_dictionary: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        mounted() {
            //this.featureList = this.getBundleItemFeatures(this.bundle_item);

            if (this.bundleItemIsSelected(this.bundle_item) || this.bundle_item.is_mandatory === '1') {
                this.selectStatementType(this.bundle_item)
            }
        },
        computed: {
            totalSellingOptions: function () {
                let total = 0.00;

                if (this.objectIsNotEmpty(this.bundle_item.service_charges)) {
                    let selected_service_charges = this.bundle_item.service_charges.filter(obj => obj.selected === '1');

                    selected_service_charges.forEach(obj => {
                        if (obj.service_frequency === '1') {
                            let value = !!obj.default_base_charge && obj.default_base_charge !== '' ? obj.default_base_charge :
                                !!obj.maximum_base_charge && obj.maximum_base_charge !== '' ? obj.maximum_base_charge : 0.00;
                            total = parseFloat(total) + parseFloat(value)
                        }
                    })
                }

                return this.convertToDecimal(total);
            },
            featureDictionary: function () {
                let feature_dictionary = {};
                let vm = this;
                let featureList = vm.getBundleItemFeatures(vm.bundle_item);
                if (Array.isArray(featureList)) {
                    featureList.forEach(feature => {
                        if (feature.value && feature.value.includes(",")) {
                            feature.value = feature.value.split(",")[0];
                        }
                        feature.disabled = vm.getFeatureDisabledFlag(feature)
                        feature_dictionary[feature['feature_api_code']] = feature;
                    });
                }
                return feature_dictionary;
            },
            statementFeatureApiCode: function () {
                let service_api_code = this.bundle_item.service.service_api_code;
                return this.statementTypes[service_api_code];
            },
            statementType: function () {
                  if(!!this.statementFeatureApiCode && !!this.featureDictionary) {
                      return this.featureDictionary[this.statementFeatureApiCode];
                  }
                  return null;
            },
            featureListValuesDictionary: function () {
                // let featureListValues = Object.values(this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM']).find(obj => {
                //     return obj['feature_list_value_external_id'] === pciContact
                // });
                let feature_lists = this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM'];
                let featureListValues = Object.fromEntries(
                    Object.entries(feature_lists)
                        .map(([key, val]) => [val['feature_list_value_external_id'], val])
                );
                return featureListValues;
            }
        },
        methods: {
            itemHasDescription: function (bundle_item) {
                return bundle_item.service.hasOwnProperty('service_description') &&
                    bundle_item.service.service_description !== '';
            },
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            selectStatementType: function (bundle_item) {
                //TODO need to rewrite this accurately set the bundle item value correctly and remove the on-select and deselect options
                if(!bundle_item.terminal_quantity > 0 ){
                    bundle_item.terminal_quantity = 1
                    bundle_item.selected = true;
                    bundle_item.is_boarding_activated = '1';
                }
                if (bundle_item.is_boarding_activated === '1' || bundle_item.is_mandatory === '1') {
                    if (this.featureDictionary.hasOwnProperty(this.statementFeatureApiCode)) {
                        //set value on select
                        this.featureDictionary[this.statementFeatureApiCode]['value'] = this.featureDictionary[this.statementFeatureApiCode].hasOwnProperty('collect_on_value') ?
                            this.featureDictionary[this.statementFeatureApiCode]['collect_on_value'] : this.featureDictionary[this.statementFeatureApiCode]['default_value'];

                        //set the disabled field based on collect_on_boarding
                        this.setFeatureDisabledFlag(this.statementFeatureApiCode)
                        // if (this.featureDictionary[this.statementFeatureApiCode]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                        //     this.featureDictionary[this.statementFeatureApiCode]['disabled'] = true
                        // } else if (this.featureDictionary[this.statementFeatureApiCode]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                        //     this.featureDictionary[this.statementFeatureApiCode]['disabled'] = true;
                        // } else {
                        //     this.featureDictionary[this.statementFeatureApiCode]['disabled'] = false;
                        // }
                    }
                }
                if (!!this.statementType) {
                    this.featureDictionary[this.statementFeatureApiCode]['selected'] = '1';
                }
                if (this.featureDictionary.hasOwnProperty('media')) {
                    this.featureDictionary['media']['selected'] = '1';
                    this.selectItem('media');

                    if (this.featureDictionary['media'].hasOwnProperty('value')) {
                        let media_data = this.featureListValuesDictionary[this.featureDictionary['media'].value];
                        if (media_data.hasOwnProperty('value') && media_data.value === this.mediaTypes.EMAIL) {
                            this.selectStatementEmail();
                        }
                        else {
                            this.deSelectStatementEmail();
                        }
                    }
                }

                if (this.featureDictionary.hasOwnProperty('frequency')) {
                    if (this.statementFeatureApiCode === this.statementTypes.fundingStatement) {
                        this.featureDictionary['frequency']['selected'] = '1';
                        this.selectItem('frequency');
                    }
                    else {
                        this.featureDictionary['frequency']['selected'] = '0';
                    }
                }

                if (bundle_item.is_boarding_activated === '0' && bundle_item.is_mandatory === '0'){
                    //disable all fields if service is deselected and change values
                    Object.values(this.featureDictionary).forEach(feature => {
                        feature.disabled = true;
                        //unset feature value if collected from user
                        if (feature.collect_on_boarding === this.collect_on_boarding_types.BOARDING){
                            feature.value = '';
                            feature.selected = '';
                        }
                    })
                }

            },
            selectItem: function (item, is_required = false) {
                if (this.featureDictionary.hasOwnProperty(item)) {
                    //set value on select
                    this.featureDictionary[item]['value'] = !!this.featureDictionary[item]['value'] ? this.featureDictionary[item]['value'] :
                        this.featureDictionary[item].hasOwnProperty('collect_on_value') ?
                            this.featureDictionary[item]['collect_on_value'] : this.featureDictionary[item]['default_value'];

                    //set the disabled field based on collect_on_boarding
                    this.setFeatureDisabledFlag(item)
                    // if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                    //     this.featureDictionary[item]['disabled'] = true
                    // } else if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                    //     this.featureDictionary[item]['disabled'] = true;
                    // } else {
                    //     this.featureDictionary[item]['disabled'] = false;
                    // }

                    this.featureDictionary[item]['selected'] = '1';

                    if (!!is_required){
                        this.featureDictionary[item]['required'] = true;
                    }
                }

                // if(this.featureDictionary[item]['collect_on_boarding'] ===  this.collect_on_boarding_types.OFFER) {
                //     this.featureDictionary[item]['value'] = this.featureDictionary[item]['collect_on_value'];
                //     this.featureDictionary[item]['disabled'] = true;
                // }
            },
            getFeatureDisabledFlag: function (feature) {
                let disabled = false
                if (feature && feature.hasOwnProperty('collect_on_boarding')) {
                    let {collect_on_boarding} = feature

                    if (collect_on_boarding === this.collect_on_boarding_types.OFFER ||
                        collect_on_boarding === this.collect_on_boarding_types.CONFIG) {
                        disabled = true
                    }
                }
                return disabled;
            },
            setFeatureDisabledFlag: function (item){
                if (this.featureDictionary.hasOwnProperty(item)) {
                    //set the disabled field based on collect_on_boarding
                    if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                        this.featureDictionary[item]['disabled'] = true
                    } else if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                        this.featureDictionary[item]['disabled'] = true;
                    } else {
                        this.featureDictionary[item]['disabled'] = false;
                    }
                }
            },
            prepFeatureDictionary: function (bundle_item) {
                let bundle_item_features = this.getBundleItemFeatures(bundle_item);
                let feature_dictionary = {};
                bundle_item_features.forEach(feature => {
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            isSelectedFeature: function (feature_api_code) {
                if (this.featureDictionary.hasOwnProperty(feature_api_code) && this.featureDictionary[feature_api_code]['selected'] === '1') {
                    return true;
                }
                return false;
            },
            selectStatementEmail: function () {
                if (this.featureDictionary.hasOwnProperty('emailAddress')) {
                    //if pciContact is pre-populate
                    let media = this.featureDictionary.media.value;
                    let mediaListValue = this.featureListValuesDictionary[media];

                    if (mediaListValue['value'] === this.mediaTypes.EMAIL) {
                        this.featureDictionary.emailAddress['selected'] = '1';
                    }
                    if (mediaListValue['value'] !== this.mediaTypes.EMAIL) {
                        this.featureDictionary.emailAddress['selected'] = '';
                        this.featureDictionary.emailAddress['value'] = '';
                    }
                }
            },
            deSelectStatementEmail: function () {
                if (this.featureDictionary.hasOwnProperty('emailAddress')) {
                    this.featureDictionary.emailAddress['selected'] = '';
                    this.featureDictionary.emailAddress['value'] = '';
                }
            },
            itemIsSelected: function (bundle_item) {
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            getServiceChargeDescription: function (service_charge) {
                return service_charge.service_item_name + ' - ' + this.getServiceCharge(service_charge) + (service_charge.service_frequency !== '1' ? `/${this.formatServiceFrequency(service_charge.service_frequency)}` : '');
            },
            getFeatureValue: function (feature) {
                let feature_value = !!feature.value ? feature.value : feature.default_value

                if (feature.feature_input_type === this.types.LIST) {
                    let feature_list = this.getFeatureList(feature);
                    let matched_value = feature_list.find(obj => obj.id === feature_value);

                    return !!matched_value ? `(${matched_value.text})` : '';
                } else {
                    return feature_value !== '' ? `(${feature_value})` : '';
                }
            }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
